/* eslint-disable no-unused-vars */
export interface TeamMember {
  id: number;
  name: string;
  email: string;
  phone_number: number;
  role: 'agency_admin' | 'agency_admin_readonly' | 'agent_builder';
  avatar_url: string | null;
}

export interface TeamMemberRequest {
  team_member: {
    name: string;
    email: string;
    phone_number: number;
    role: 'agency_admin' | 'agency_admin_readonly' | 'agent_builder';
  };
}

export enum TeamMemberRole {
  AgencyAdmin = 'agency_admin',
  AgencyAdminReadonly = 'agency_admin_readonly',
  AgentBuilder = 'agent_builder'
}
